import PropTypes from 'prop-types';
import { readingTime } from 'reading-time-estimator';
import styles from './blogPostPreviewCard.module.scss';
import placeHolderImage from './blogPostPreviewCardPlaceHolder.svg';
import SmartImage from '../smartImage/smartImage';

export default function BlogPostPreviewCard({
  mode = 1,
  post = {},
  previewCardClassName = '',
}) {
  if (Object.keys(post).length === 0) {
    return null;
  }
  const { product, date, postContent, excerpt, thumbnail, title, url } = post;
  const formatDate = new Date(date).toLocaleString('en-US', {
    timeZone: 'America/Los_Angeles',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  const isplaceholder = thumbnail ? thumbnail?.isplaceholderImg : false;
  const classNameWrapper = styles[`blogPreview${mode}`];
  const classNamePlaceHolder = isplaceholder ? styles.placeholder : '';
  const leftBlogPost =
    previewCardClassName === 'leftCard' ? styles.leftCard : '';
  const rightBlogPost =
    previewCardClassName === 'rightCard' ? styles.rightCard : '';
  const stats = readingTime(postContent ?? '');
  const timeDuration = stats.text;
  const thumbnailWrapper = thumbnail ? (
    <div className={styles.thumbnail}>
      <a href={url}>
        {isplaceholder ? (
          <SmartImage
            className={`${styles.thumbnailImage} ${classNamePlaceHolder}`}
            src={placeHolderImage.src}
            data-testid="prevWithPlaceholder"
            priority
            alt={title}
            width={600}
            height={600}
            quality={100}
            unoptimized
          />
        ) : (
          <SmartImage
            src={thumbnail.src}
            className={styles.thumbnailImage}
            data-testid="prevWithThumbnail"
            priority
            alt={thumbnail.alt}
            width={600}
            height={600}
            quality={100}
            unoptimized
          />
        )}
      </a>
    </div>
  ) : null;
  return (
    <div className={`${classNameWrapper} ${leftBlogPost} ${rightBlogPost}`}>
      {thumbnailWrapper}
      <div className={`${styles.summary} ${previewCardClassName}`}>
        {mode !== 3 && product && (
          <span className={styles.category}>{product}</span>
        )}
        {title && (
          <h3 className={styles.title}>
            <a className={styles.titleLink} href={url}>
              {title}
            </a>
          </h3>
        )}
        {excerpt && <p className={styles.excerpt}>{excerpt}</p>}
        {mode !== 3 && (
          <a className={styles.readMore} href={url}>
            Read More
          </a>
        )}
        {mode === 3 && (product || date || timeDuration) && (
          <ul className={`${styles.subDetails}`}>
            {product && (
              <li className={styles.product}>
                <a className={styles.category1} href={product.link}>
                  {product.label}
                </a>
              </li>
            )}
            {date && <li className={styles.product}>{formatDate}</li>}
            {timeDuration && (
              <li className={styles.productRead}>{timeDuration}</li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
}

BlogPostPreviewCard.propTypes = {
  /**
   * mode 1: To display hero preview card
   *
   * mode 2: To display child preview cards
   */
  mode: PropTypes.oneOf([1, 2, 3]),
  /**
   * If post response doesn't have thumbnail child, placeHolder image will be shown as a default.
   */
  post: PropTypes.shape({
    product: PropTypes.any,
    date: PropTypes.string,
    postContent: PropTypes.string,
    excerpt: PropTypes.string,
    thumbnail: PropTypes.shape({
      alt: PropTypes.string,
      src: PropTypes.string,
    }),
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  previewCardClassName: PropTypes.string,
};
